import BlogCard from './BlogCard';
const BlogList = ({blogs}) => {
  return (
    <div className="flex flex-wrap justify-center items-center gap-[20px] sm:gap-[20px] xl:gap-[40px] pt-1 pb-4 px-1">
      {blogs?.map((blog) => {
        return (
          <BlogCard
            key={blog.link}
            title={blog.title}
            description={blog.content}
            image={blog.image}
            link={blog.link}
            date={blog.date}
            external={blog.external}
        />
      )})}
      <div className="h-[40px] w-full">&nbsp;</div>
    </div>
  );
};

export default BlogList;